import { render, staticRenderFns } from "./CGVProposals.vue?vue&type=template&id=3e7d239d&scoped=true"
import script from "./CGVProposals.vue?vue&type=script&lang=js"
export * from "./CGVProposals.vue?vue&type=script&lang=js"
import style0 from "./CGVProposals.vue?vue&type=style&index=0&id=3e7d239d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d239d",
  null
  
)

export default component.exports